import { graphql } from "~/gql";

export const DELETE_BRAND = graphql(/* GraphQL */ `
  mutation deleteBrand($id: Float!) {
    deleteBrand(id: $id) {
      brandId
    }
  }
`);
